module.exports = __webpack_public_path__ + "static/media/S (149).6c69fe95.jpg";